var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.72876 30 0 23.2713 0 15.0002C0 6.72903 6.7291 0 15 0C23.2709 0 30 6.72903 30 15.0002C30 23.2713 23.2709 30 15 30ZM15 1.01156C7.28663 1.01156 1.01124 7.28688 1.01124 15.0005C1.01124 22.7138 7.28663 28.9891 15 28.9891C22.7134 28.9891 28.9888 22.7141 28.9888 15.0005C28.9888 7.28688 22.713 1.01156 15 1.01156Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5486 21.8674H11.498C10.9802 21.8674 10.4905 21.6537 10.119 21.2661L5.60687 16.5627C4.81845 15.7408 4.79519 14.3777 5.55496 13.524C5.93283 13.0999 6.44081 12.8662 6.98519 12.8662C7.50193 12.8662 7.99137 13.0799 8.3635 13.4679L11.4144 16.6477L19.9101 6.6914C20.285 6.252 20.8172 6 21.3704 6C21.8709 6 22.3496 6.20239 22.7173 6.57033C23.107 6.95869 23.3338 7.48927 23.3551 8.06288C23.376 8.63649 23.1899 9.18421 22.8302 9.60575L12.9572 21.176C12.5979 21.5979 12.0865 21.8503 11.5556 21.8667L11.5486 21.8674ZM6.98519 13.9605C6.71788 13.9605 6.46845 14.075 6.28305 14.2832C5.91024 14.7022 5.92137 15.3717 6.30867 15.7754L10.8211 20.4788C11.0035 20.6688 11.2435 20.7738 11.498 20.7738H11.533C11.7912 20.764 12.039 20.6407 12.2139 20.435L22.087 8.8644C22.2633 8.65764 22.355 8.38852 22.3445 8.107C22.3344 7.82549 22.2232 7.56548 22.0317 7.37477C21.6471 6.99078 21.006 7.01995 20.6534 7.43384L11.4572 18.2114L7.6617 14.2559C7.47901 14.0655 7.23901 13.9605 6.98519 13.9605Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/doneIcon.b2d6f7f4d631841009843f794b27be98.svg";
export { ForwardRef as ReactComponent };